import React from 'react';
import { ChatMessage } from '../../types';
import { ChatMarkdownContent } from './ChatMarkdownContent';
import ContextChipList from './ContextChipList';
import styles from '../ChatWidget.module.scss';

interface MessageBubbleProps {
  message: ChatMessage;
  isGrouped?: boolean;
  isActiveToolCall?: boolean;
}

function formatTime(date: Date): string {
  return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

export default function MessageBubble(props: MessageBubbleProps) {
  const { message, isGrouped, isActiveToolCall } = props;
  const isUser = message.role === 'user';
  const isToolActivity = message.role === 'tool-activity';
  const showAvatar = !isUser && !isGrouped;

  if (isToolActivity) {
    return (
      <div
        className={`${styles.messageRow} ${styles.messageRowAssistant} ${isGrouped ? styles.messageRowGrouped : ''}`}
        data-testid="chat-message-bubble-tool-activity"
      >
        {showAvatar ? (
          <div className={styles.bubbleAvatar}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="4" width="18" height="14" rx="3" stroke="#64748B" strokeWidth="1.5" />
              <circle cx="9" cy="10" r="1.5" fill="#64748B" />
              <circle cx="15" cy="10" r="1.5" fill="#64748B" />
              <path d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </div>
        ) : (
          <div className={styles.bubbleAvatarSpacer} />
        )}
        <div className={styles.bubbleWrapper}>
          <div className={styles.toolActivityBubble}>
            <span className={isActiveToolCall ? styles.toolActivityIndicatorActive : styles.toolActivityIndicator} />
            {message.content}
          </div>
        </div>
      </div>
    );
  }

  const bubbleClassName = isUser
    ? styles.userBubble
    : message.isError
      ? styles.errorBubble
      : styles.assistantBubble;

  return (
    <div
      className={`${styles.messageRow} ${isUser ? styles.messageRowUser : styles.messageRowAssistant} ${!isUser && isGrouped ? styles.messageRowGrouped : ''}`}
      data-testid={`chat-message-bubble-${message.role}`}
    >
      {!isUser && (
        showAvatar ? (
          <div className={styles.bubbleAvatar}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="4" width="18" height="14" rx="3" stroke="#64748B" strokeWidth="1.5" />
              <circle cx="9" cy="10" r="1.5" fill="#64748B" />
              <circle cx="15" cy="10" r="1.5" fill="#64748B" />
              <path d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </div>
        ) : (
          <div className={styles.bubbleAvatarSpacer} />
        )
      )}
      <div className={styles.bubbleWrapper}>
        {!isUser && !isGrouped && (
          <div className={styles.bubbleMeta}>
            <span className={styles.bubbleSender}>Nekst AI</span>
            <span className={styles.bubbleTime}>{formatTime(message.timestamp)}</span>
          </div>
        )}
        <div className={bubbleClassName}>
          {isUser ? (
            message.content
          ) : (
            <ChatMarkdownContent content={message.content} />
          )}
        </div>
        {isUser && message.context && message.context.length > 0 && (
          <div className={styles.messageContextArea}>
            <ContextChipList context={message.context} />
          </div>
        )}
        {isUser && (
          <div className={`${styles.bubbleMeta} ${styles.bubbleMetaRight}`}>
            <span className={styles.bubbleTime}>You &bull; {formatTime(message.timestamp)}</span>
          </div>
        )}
      </div>
    </div>
  );
}
